/**
 * The context-snapshot fields the ticket sidebar has a label for.
 *
 * A JSX-free module rather than a constant inside the page, so the list and the catalogue can be
 * checked against each other by a spec — see `locale-parity.spec.ts`. Adding a field to the API's
 * snapshot without adding its two translations is otherwise invisible: the sidebar just prints
 * the raw field name.
 */
export const SUPPORT_CONTEXT_FIELDS = [
  'tier',
  'subscriptionStatus',
  'isInTrial',
  'invoiceCount',
  'creditNoteCount',
  'openAlertCount',
  'openAttentionItemCount',
  'taxScheme',
  'usesFallbackSmtp',
  'smtpConsecutiveFailures',
  'onboardingComplete',
  'capturedAt',
  'unavailableReason',
] as const;

/**
 * Catalogue key for a snapshot field, or `null` when there is no label for it.
 *
 * `null` rather than the dotted path is the point: a field the API adds later must fall back to
 * its RAW name, because `support.ticket.context.newThing` is worse to read in a sidebar than
 * `newThing`.
 */
export function supportContextLabelKey(field: string): string | null {
  return (SUPPORT_CONTEXT_FIELDS as readonly string[]).includes(field)
    ? `support.ticket.context.${field}`
    : null;
}
